export default function Mission() {
  return (
    <section id="mission" className="py-24 md:py-32 bg-primary">
      <div className="container">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-sm font-bold text-accent uppercase tracking-[0.2em] mb-6">Our Mission</h2>
          <h3 className="text-4xl md:text-6xl font-bold font-heading text-white uppercase tracking-tight leading-[0.95] mb-8">
            Grow Alongside <br /> <span className="text-accent">Challenger Brands.</span>
          </h3>
          <div className="text-lg text-slate-300 leading-relaxed space-y-4 max-w-2xl mx-auto">
            <p>We exist to grow alongside the brands we work with — as a long-term digital partner invested in your trajectory, not just your next campaign.</p>
            <p>Our strategies and budgets scale with your business. Whether you&apos;re finding traction, compounding growth, or defending market share, we build systems and shared momentum that compound over time.</p>
          </div>
        </div>
      </div>
    </section>
  )
}
